import { PDF_TOOLS_PROMPT } from '../prompts/pdf-tools';

export function buildPdfOperationContext(operationResult: string): string {
    return `\n\n[CRITICAL SYSTEM INSTRUCTION: The user's request to convert or manipulate a file HAS ALREADY BEEN COMPLETED by the backend PDF-Tools orchestrator. The files have already been processed and downloaded to the user's machine. 
Result Status: "${operationResult}"
YOUR ONLY TASK: You MUST confirm to the user that the operation was successful and the files were downloaded. DO NOT apologize or claim you lack the capability to convert files, because the system has already done it for you. Act as if you orchestrated the successful conversion.]\n`;
}

export function buildPdfQaContext(extractedText: string, filename: string, attachmentIndex: number): string {
    return `\n\n[System: The PDF-Tools bridge has extracted the following text from attached PDF #${attachmentIndex} ("${filename}"):\n${extractedText}\n\nUse this text to answer any questions the user has about the PDF.]`;
}
